import classNames from 'classnames';
import React, { HTMLAttributes, useEffect, useState } from 'react';
import styles from './Backdrop.module.css';

export type BackdropProps = {
  show: boolean;
} & HTMLAttributes<HTMLDivElement>;

const Backdrop = ({ children, show, className, ...props }: BackdropProps) => {
  const [mounted, setMounted] = useState(show);

  useEffect(() => {
    if (show) {
      setMounted(true);
    }
  }, [show]);

  const onAnimationEnd = () => {
    if (!show) {
      setMounted(false);
    }
  };

  const containerClassName = classNames(styles.container, className, {
    [styles.fadein]: show,
    [styles.fadeout]: !show,
  });

  if (!mounted) {
    return null;
  }

  return (
    <div
      className={containerClassName}
      onAnimationEnd={onAnimationEnd}
      {...props}
    >
      {children}
    </div>
  );
};

export default Backdrop;
